// Constant value to keep marquee speeds consistent across all ticker components
export const TICKER_ITEM_DURATION = 5;